import React from 'react';
import styles from './index.module.scss';
import cs from 'classnames';
const LightShadow = () => {
  return <div className={cs('w-full h-full', styles.shimmerContainer)}></div>;
};

export default LightShadow;
